const showInvalidDateError = date => {
  const isDateInvoked = date.touched || date.visited || !!date.value;
  return isDateInvoked && date.error;
};

export default showInvalidDateError;
